import type { IconType } from 'react-icons';
import { FaFacebook, FaGithub, FaInstagram, FaLinkedin, FaQuora, FaStackOverflow } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import TopmateIcon from '@/components/icons/TopmateIcon';

const socialBrandIcons: Record<string, IconType | React.FC<{ className?: string }>> = {
  facebook: FaFacebook,
  github: FaGithub,
  instagram: FaInstagram,
  linkedin: FaLinkedin,
  quora: FaQuora,
  stackoverflow: FaStackOverflow,
  twitter: FaXTwitter,
  topmate: TopmateIcon as any,
};

export const getBrandIcon = (id: string): IconType | React.FC<{ className?: string }> | null => socialBrandIcons[id] ?? null;
